import { render, staticRenderFns } from "./ZonesAdd.vue?vue&type=template&id=36afde34"
import script from "./ZonesAdd.vue?vue&type=script&lang=js"
export * from "./ZonesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports